import { Pagination } from '@/ui/components/Pagination'
import { cn } from '@/utils/ui'
import React from 'react'

export const ArchivePagination = ({
  loadMoreStrategy,
  currentPage,
  totalPages,
  onPageChange,
  isLoading,
  paginationId,
  loadMoreText,
}: {
  loadMoreStrategy: 'none' | 'pagination' | 'loadMoreButton'
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  isLoading: boolean
  paginationId: string
  loadMoreText: string
}) => {
  if (loadMoreStrategy === 'none' || totalPages <= 1) return null

  if (loadMoreStrategy === 'pagination') {
    return (
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
        isLoading={isLoading}
      />
    )
  }

  // loadMoreButton case
  return (
    <div className="mt-8 text-center">
      <button
        disabled={isLoading || currentPage >= totalPages}
        className={cn(
          'px-4 py-2 rounded text-white bg-primary hover:bg-primary-dark',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          isLoading ? 'relative pl-8' : '',
        )}
        onClick={() => onPageChange(currentPage + 1)}
      >
        {isLoading && (
          <span className="absolute left-3 top-1/2 -mt-2 h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
        )}
        {loadMoreText}
      </button>
    </div>
  )
}
